import {
  SET_AUTH_USER,
  SET_AUTH_USER_STATUS,
} from './mutation-types'
import api from '@/api'
import {removeToken} from '@/utils/auth'
import {jumpToLogin} from '../../../api/config/default'

const state = {
  isLoggedIn: false,
}

const mutations = {
  [SET_AUTH_USER] (state, payload) {
    state.user = payload
  },
  [SET_AUTH_USER_STATUS] (state, payload) {
    state.isLoggedIn = payload
  },
}

const actions = {
  async userLogin ({commit, dispatch}, payload) {
    const data = await api.authApi.login(payload)
    if (data.code === 200) {
      commit(SET_AUTH_USER_STATUS, true)
      dispatch('home/getUserInfo', null, {root: true})
    }
    return data
  },
  async userLogout ({state, commit}, payload) {
    const data = await api.authApi.logout()
    removeToken()
    commit(SET_AUTH_USER_STATUS, false)
    commit('home/SET_USERINFO', '', {root: true})
    jumpToLogin(false)
    return data
  },
  async loginVerifyCode ({state}, payload) {
    const data = await api.authApi.loginVerifyCode(payload)
    return data
  },
  async isInitialLogin ({state}, payload) {
    const data = await api.authApi.isInitialLogin(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
